import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../__root";

export const communitiesNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/communities/new",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "CommunitiesOnboarding" */ "@circle-react/components/OnboardingPage/CreateCommunityPage"
      ),
    "CreateCommunityPage",
  ),
});
